module.exports = __webpack_public_path__ + "img/signIn.98ed879d.svg";